<template>
	<lcsj-dialog v-model="showDialog" ref="processOrderDetailDialog" :title="'加工订单详情 - ' + (detailData.orderNo || '')" width="85%" append-to-body @close="closeDialog" cancel-text="关闭">
		<template #footer>
			<div class="dialog-footer">
				<el-button v-if="canConfirm" size="small" type="primary" @click="handleConfirm">确认订单</el-button>
				<el-button v-if="canConfirm" size="small" type="danger" @click="handleReturn">退回</el-button>
				<el-button v-if="canOutput" size="small" type="success" @click="outputDialogVisible = true">出库</el-button>
				<el-button v-if="canCancelStore" size="small" type="warning" @click="handleCancelOutputStore">作废出库单</el-button>
				<el-button v-if="detailData.state === 5" size="small" type="primary" @click="handleFinished">标记完成</el-button>
				<el-button v-if="canCancel" size="small" type="danger" @click="handleCancel">撤单</el-button>
				<el-button size="small" @click="closeDialog">关闭</el-button>
			</div>
		</template>
<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<!-- 明细页 -->
			<div v-if="activeTab === '1'">
				<el-descriptions :column="3" border size="small" class="detail-desc">
					<el-descriptions-item label="订单编号">{{ detailData.orderNo || "--" }}</el-descriptions-item>
					<el-descriptions-item label="需求门店">{{ detailData.belongStoreName || "--" }}</el-descriptions-item>
					<el-descriptions-item label="加工方">{{ detailData.processStoreName || "--" }}</el-descriptions-item>
					<el-descriptions-item label="加工类型">
						<span>{{ detailData.processTypeStr || "--" }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="订单状态">
						<span>{{ detailData.stateStr || "--" }}</span>
					</el-descriptions-item>
					<el-descriptions-item label="加工方式">{{ detailData.machinTypeStr || "--" }}</el-descriptions-item>
					<el-descriptions-item label="顾客">{{ detailData.customerName || "--" }}</el-descriptions-item>
					<el-descriptions-item label="顾客电话">{{ detailData.customerPhone || "--" }}</el-descriptions-item>
					<el-descriptions-item label="验光师">{{ detailData.yanGuangShi || "--" }}</el-descriptions-item>
					<el-descriptions-item label="下单日期">{{ detailData.orderDate || "--" }}</el-descriptions-item>
					<el-descriptions-item label="取单日期">{{ detailData.getOrderDate || "--" }}</el-descriptions-item>
					<el-descriptions-item label="镜架信息">{{ detailData.jjInformation || "--" }}</el-descriptions-item>
					<el-descriptions-item label="出库单号">{{ detailData.outputStoreNo || "--" }}</el-descriptions-item>
					<el-descriptions-item label="确认人">{{ detailData.confirmUserName || "--" }}</el-descriptions-item>
					<el-descriptions-item label="确认时间">{{ detailData.confirmTime || "--" }}</el-descriptions-item>
					<el-descriptions-item label="备注" :span="3">{{ detailData.remark || "--" }}</el-descriptions-item>
				</el-descriptions>

				<div class="detail-block-title">加工明细</div>
				<el-table class="lcsj-data-table" :data="detailData.dtls || []" border size="small" style="width: 100%">
					<el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
					<el-table-column label="左右眼" width="80" align="center">
						<template #default="scope">{{ scope.row.lr === 1 ? "左眼" : "右眼" }}</template>
					</el-table-column>
					<el-table-column label="商品品牌" width="140" align="center">
						<template #default="scope">{{ scope.row.goodsBrand || "--" }}</template>
					</el-table-column>
					<el-table-column label="商品名称" min-width="180" align="center">
						<template #default="scope">{{ scope.row.goodsName || "--" }}</template>
					</el-table-column>
					<el-table-column label="球镜" width="80" align="center">
						<template #default="scope">{{ scope.row.qiuJing || "--" }}</template>
					</el-table-column>
					<el-table-column label="柱镜" width="80" align="center">
						<template #default="scope">{{ scope.row.zhuJing || "--" }}</template>
					</el-table-column>
					<el-table-column label="轴位" width="70" align="center">
						<template #default="scope">{{ scope.row.zhouWei }}</template>
					</el-table-column>
					<el-table-column label="需求数量" width="90" align="center">
						<template #default="scope">{{ scope.row.quantity }}</template>
					</el-table-column>
					<el-table-column label="已出库" width="80" align="center">
						<template #default="scope">{{ scope.row.outputQty }}</template>
					</el-table-column>
					<el-table-column label="可用库存" width="90" align="center">
						<template #default="scope">
							<span :class="scope.row.isShortage ? 'text-danger' : ''">{{ scope.row.wareHouseQuantity }}</span>
						</template>
					</el-table-column>
					<el-table-column label="在途采购" width="90" align="center">
						<template #default="scope">{{ scope.row.onWayQuantity }}</template>
					</el-table-column>
					<el-table-column label="缺口" width="80" align="center">
						<template #default="scope">
							<span v-if="scope.row.isShortage" class="text-danger">是</span>
							<span v-else>否</span>
						</template>
					</el-table-column>
					<el-table-column label="备注" min-width="120" align="center">
						<template #default="scope">{{ scope.row.remark || "--" }}</template>
					</el-table-column>
				</el-table>
			</div>

			<!-- 操作记录页 -->
			<div v-if="activeTab === '2'">
				<el-table class="lcsj-data-table" :data="historyList" border size="small" v-loading="historyLoading" style="width: 100%">
					<el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
					<el-table-column label="操作类型" width="140" align="center">
						<template #default="scope">{{ scope.row.operateTypeStr || "--" }}</template>
					</el-table-column>
					<el-table-column label="操作内容" min-width="260" align="center">
						<template #default="scope">{{ scope.row.content || "--" }}</template>
					</el-table-column>
					<el-table-column label="关联单号" width="220" align="center">
						<template #default="scope">{{ scope.row.linkNo || "--" }}</template>
					</el-table-column>
					<el-table-column label="操作人" width="120" align="center">
						<template #default="scope">{{ scope.row.creator || "--" }}</template>
					</el-table-column>
					<el-table-column label="操作时间" width="170" align="center">
						<template #default="scope">{{ scope.row.createTime || "--" }}</template>
					</el-table-column>
				</el-table>
				<Pagination v-if="historyPageShow" :child-msg="historyParm" @call-father="historyCallFather"></Pagination>
			</div>
		</topTab>

		

		<!-- 出库方式选择 -->
		<lcsj-dialog v-model="outputDialogVisible" title="选择出库方式" width="620px" append-to-body cancel-text="" confirm-text="">
			<el-alert title="一个订单只允许出库一次；库存不足时请先创建采购单，采购入库后再出库。" type="info" :closable="false" show-icon></el-alert>
			<div class="output-way-list">
				<div class="output-way-item" @click="handleStockOutput">
					<div class="way-title">库存出库</div>
					<div class="way-desc">使用工厂店现有库存出库，库存不足时仅提示、不改变订单状态。</div>
				</div>
				<div class="output-way-item" @click="handlePurchaseOutput">
					<div class="way-title">创建采购单出库</div>
					<div class="way-desc">库存不足时生成采购单，订单转为「采购中」，采购入库后再执行出库。</div>
				</div>
				<div class="output-way-item" @click="handleEditGoodsOutput">
					<div class="way-title">更换商品出库</div>
					<div class="way-desc">逐行更换实际出库商品，新商品库存不足则只提示、不改变订单状态。</div>
				</div>
			</div>
			
		</lcsj-dialog>

		<!-- 库存出库预览 -->
		<lcsj-dialog v-model="previewVisible" title="库存出库预览" width="760px" cancel-text="取消" confirm-text="确认出库"
			 :confirm-disabled="!previewData.allEnough"
			 :confirm-loading="outputLoading"
			 :close-on-click-modal="false"
			 append-to-body
			 @confirm="submitStockOutput">
			<el-alert v-if="previewData.allEnough" title="库存充足，可执行出库。" type="success" :closable="false" show-icon></el-alert>
			<el-alert v-else title="存在库存不足的明细，无法出库。请改用「创建采购单出库」补货。" type="warning" :closable="false" show-icon></el-alert>
			<el-table class="lcsj-data-table" :data="previewData.dtls || []" border size="small" style="width: 100%; margin-top: 10px">
				<el-table-column label="左右眼" width="80" align="center">
					<template #default="scope">{{ scope.row.lr === 1 ? "左眼" : "右眼" }}</template>
				</el-table-column>
				<el-table-column label="商品名称" min-width="180" align="center">
					<template #default="scope">{{ scope.row.goodsName || "--" }}</template>
				</el-table-column>
				<el-table-column label="球镜" width="80" align="center" prop="qiuJing"></el-table-column>
				<el-table-column label="柱镜" width="80" align="center" prop="zhuJing"></el-table-column>
				<el-table-column label="需求数量" width="90" align="center" prop="quantity"></el-table-column>
				<el-table-column label="可用库存" width="90" align="center" prop="stockQuantity"></el-table-column>
				<el-table-column label="缺口" width="80" align="center">
					<template #default="scope">
						<span :class="scope.row.isShortage ? 'text-danger' : ''">{{ scope.row.shortageQuantity }}</span>
					</template>
				</el-table-column>
				<el-table-column label="在途采购" width="90" align="center" prop="onWayQuantity"></el-table-column>
			</el-table></lcsj-dialog>

		<!-- 更换商品出库 -->
		<lcsj-dialog v-model="editGoodsVisible" title="更换商品出库" width="900px" cancel-text="取消" confirm-text="确认出库"
			 :confirm-loading="outputLoading"
			 :close-on-click-modal="false"
			 append-to-body
			 @confirm="submitEditGoodsOutput">
			<el-alert title="出库单会记录更换前的原商品，订单明细保持顾客原始需求不变。" type="info" :closable="false" show-icon></el-alert>
			<el-table class="lcsj-data-table" :data="editGoodsList" border size="small" style="width: 100%; margin-top: 10px">
				<el-table-column label="左右眼" width="80" align="center">
					<template #default="scope">{{ scope.row.lr === 1 ? "左眼" : "右眼" }}</template>
				</el-table-column>
				<el-table-column label="原商品名称" min-width="170" align="center">
					<template #default="scope">{{ scope.row.originGoodsName || "--" }}</template>
				</el-table-column>
				<el-table-column label="更换后商品" min-width="200" align="center">
					<template #default="scope">
						<el-input v-model="scope.row.goodsName" clearable readonly placeholder="请选择商品" @focus="handleSelectEditGoods(scope.$index)">
							<el-button slot="append" icon="el-icon-search" @click="handleSelectEditGoods(scope.$index)">选择</el-button>
						</el-input>
					</template>
				</el-table-column>
				<el-table-column label="轴位" width="100" align="center">
					<template #default="scope">
						<el-input v-model.number="scope.row.zhouWei" size="small" type="number" placeholder="轴位"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="数量" width="100" align="center">
					<template #default="scope">
						<el-input v-model.number="scope.row.quantity" size="small" type="number" placeholder="数量"></el-input>
					</template>
				</el-table-column>
				<el-table-column label="备注" min-width="130" align="center">
					<template #default="scope">
						<el-input v-model="scope.row.remark" size="small" clearable placeholder="备注"></el-input>
					</template>
				</el-table-column>
			</el-table></lcsj-dialog>

		<selectGoods ref="selectGoods"></selectGoods>
	</lcsj-dialog>
</template>

<script>
import {
	GetProcessOrderInfo,
	GetProcessOrderHistory,
	ConfirmProcessOrder,
	ReturnProcessOrder,
	CancelProcessOrder,
	FinishedProcessOrder,
	PreviewProcessOutputStore,
	CreateProcessOutputStore,
	EditGoodsProcessOutputStore,
	CancelProcessOutputStore,
	CreatePurchaseProcessOutputStore
} from "@/api/processApi.js";
import selectGoods from "@/views/baseData/goods/selectGoods.vue";
export default {
	components: {
		selectGoods
	},
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showDialog: false,
			activeTab: "1",
			tabData: [
				{ key: "1", value: "订单明细" },
				{ key: "2", value: "操作记录" }
			],
			keyId: "",
			detailData: {},
			outputDialogVisible: false,
			previewVisible: false,
			outputLoading: false,
			previewData: {},
			editGoodsVisible: false,
			editGoodsList: [],
			editGoodsIndex: -1,
			historyList: [],
			historyLoading: false,
			historyPageShow: true,
			historyParm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			}
		};
	},
	computed: {
		// 待确认可确认/退回
		canConfirm() {
			return this.detailData.state === 1;
		},
		// 仅待加工且未出库过可出库
		canOutput() {
			return this.detailData.state === 4 && this.detailData.outputFlag !== 1;
		},
		// 允许撤单：待确认 / 采购中 / 待加工
		canCancel() {
			const s = this.detailData.state;
			return s === 1 || s === 3 || s === 4;
		},
		// 有有效出库单才可作废
		canCancelStore() {
			return !!this.detailData.outputStoreKeyId && this.detailData.state !== 6;
		}
	},
	methods: {
		showSeeDetailDialog(row, type = 1) {
			this.keyId = row.keyId;
			this.activeTab = "1";
			this.showDialog = true;
			this.getInfo();
		},
		changePages(key) {
			this.activeTab = key;
			if (key === "2") {
				this.historyParm.pageIndex = 1;
				this.getHistory();
			}
		},
		getInfo() {
			GetProcessOrderInfo({ keyId: this.keyId })
				.then((res) => {
					if (res.code == 1) {
						this.detailData = res.data || {};
					} else {
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		getHistory() {
			this.historyLoading = true;
			GetProcessOrderHistory({
				keyId: this.keyId,
				pageIndex: this.historyParm.pageIndex,
				pageSize: this.historyParm.pageSize
			})
				.then((res) => {
					this.historyLoading = false;
					if (res.code == 1) {
						this.historyList = res.data || [];
						this.historyParm.total = res.totalNumber;
					} else {
						this.historyList = [];
					}
				})
				.catch(() => {
					this.historyLoading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		historyCallFather(parm) {
			this.historyParm.pageIndex = parm.currentPage == undefined ? 1 : parm.currentPage;
			this.historyParm.pageSize = parm.pageSize;
			this.getHistory();
		},
		// 刷新列表 + 详情
		refreshAll() {
			this.getInfo();
			this.$emit("refresh-list");
		},
		handleConfirm() {
			this.$confirm("确认后订单将进入下一环节，且不可再编辑。是否继续？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					ConfirmProcessOrder({ keyIds: [this.keyId] }).then((res) => {
						if (res.code == 1) {
							this.$message({ type: "success", message: "确认成功！" });
							this.refreshAll();
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					});
				})
				.catch(() => {});
		},
		handleReturn() {
			this.$prompt("请输入退回原因", "退回", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				inputType: "textarea",
				inputValidator: (value) => {
					if (!value) {
						return "退回原因不能为空";
					}
					return true;
				}
			})
				.then(({ value }) => {
					ReturnProcessOrder({ keyId: this.keyId, remark: value }).then((res) => {
						if (res.code == 1) {
							this.$message({ type: "success", message: "退回成功！" });
							this.refreshAll();
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					});
				})
				.catch(() => {});
		},
		handleCancel() {
			this.$prompt("请输入撤单原因（选填）", "撤单", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				inputType: "textarea"
			})
				.then(({ value }) => {
					CancelProcessOrder({ keyId: this.keyId, remark: value || "" }).then((res) => {
						if (res.code == 1) {
							this.$message({ type: "success", message: "撤单成功！" });
							this.refreshAll();
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					});
				})
				.catch(() => {});
		},
		handleFinished() {
			this.$confirm("确认将该订单标记为已完成吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					FinishedProcessOrder({ keyIds: [this.keyId] }).then((res) => {
						if (res.code == 1) {
							this.$message({ type: "success", message: "操作成功！" });
							this.refreshAll();
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					});
				})
				.catch(() => {});
		},
		// 方式一：库存出库 —— 先预览
		handleStockOutput() {
			this.outputDialogVisible = false;
			PreviewProcessOutputStore({ keyId: this.keyId })
				.then((res) => {
					if (res.code == 1) {
						this.previewData = res.data || {};
						this.previewVisible = true;
					} else {
						this.$message({ type: "info", message: res.msg });
					}
				})
				.catch(() => {
					this.$message.error("出库预览失败，请稍后再试！");
				});
		},
		submitStockOutput() {
			if (!this.previewData.allEnough || this.outputLoading) return;
			this.outputLoading = true;
			CreateProcessOutputStore({ keyId: this.keyId })
				.then((res) => {
					if (res.code == 1) {
						this.$message({ type: "success", message: "出库成功！" });
						this.previewVisible = false;
						this.refreshAll();
					} else {
						this.$message({ type: "info", message: res.msg, duration: 5000 });
					}
				})
				.catch(() => {
					this.$message.error("出库失败，请稍后再试！");
				})
				.finally(() => {
					this.outputLoading = false;
				});
		},
		// 方式二：创建采购单出库
		handlePurchaseOutput() {
			this.outputDialogVisible = false;
			this.$confirm("将按缺口生成采购单，订单转为「采购中」。采购入库后请再次执行出库。是否继续？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					CreatePurchaseProcessOutputStore({ keyId: this.keyId }).then((res) => {
						if (res.code == 1) {
							this.$message({ type: "success", message: res.msg, duration: 6000 });
							this.refreshAll();
						} else {
							this.$message({ type: "info", message: res.msg, duration: 5000 });
						}
					});
				})
				.catch(() => {});
		},
		// 方式三：更换商品出库
		handleEditGoodsOutput() {
			this.outputDialogVisible = false;
			const dtls = this.detailData.dtls || [];
			if (dtls.length === 0) {
				this.$message({ type: "warning", message: "该订单没有可出库的明细！" });
				return;
			}
			this.editGoodsList = dtls.map((d) => ({
				processOrderDtlKeyId: d.keyId,
				lr: d.lr,
				originGoodsKeyId: d.goodsKeyId,
				originGoodsName: d.goodsName,
				goodsKeyId: d.goodsKeyId,
				goodsName: d.goodsName,
				qiuJing: d.qiuJing,
				zhuJing: d.zhuJing,
				zhouWei: d.zhouWei,
				quantity: d.quantity,
				remark: d.remark
			}));
			this.editGoodsVisible = true;
		},
		handleSelectEditGoods(index) {
			this.editGoodsIndex = index;
			this.$refs.selectGoods.showSelectGoodsDialog(1);
		},
		chooseGoods(selectionList) {
			if (!selectionList || selectionList.length === 0 || this.editGoodsIndex < 0) {
				return;
			}
			const item = selectionList[0];
			const row = this.editGoodsList[this.editGoodsIndex];
			row.goodsKeyId = item.keyId;
			row.goodsName = item.name;
			row.qiuJing = item.qiuJing;
			row.zhuJing = item.zhuJing;
			this.editGoodsIndex = -1;
		},
		submitEditGoodsOutput() {
			const invalid = this.editGoodsList.find((d) => !d.goodsKeyId || !d.quantity || d.quantity <= 0);
			if (invalid) {
				this.$message({ type: "warning", message: "更换后的商品与数量必须填写完整且数量大于 0！" });
				return;
			}
			this.outputLoading = true;
			EditGoodsProcessOutputStore({
				keyId: this.keyId,
				dtls: this.editGoodsList.map((d) => ({
					processOrderDtlKeyId: d.processOrderDtlKeyId,
					goodsKeyId: d.goodsKeyId,
					quantity: d.quantity,
					zhouWei: d.zhouWei || 0,
					lr: d.lr,
					remark: d.remark
				}))
			})
				.then((res) => {
					if (res.code == 1) {
						this.$message({ type: "success", message: "出库成功！" });
						this.editGoodsVisible = false;
						this.refreshAll();
					} else {
						this.$message({ type: "info", message: res.msg, duration: 5000 });
					}
				})
				.catch(() => {
					this.$message.error("出库失败，请稍后再试！");
				})
				.finally(() => {
					this.outputLoading = false;
				});
		},
		handleCancelOutputStore() {
			this.$confirm("作废后库存将回补，订单回到「待加工」，可重新出库。是否继续？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					CancelProcessOutputStore({ keyId: this.detailData.outputStoreKeyId }).then((res) => {
						if (res.code == 1) {
							this.$message({ type: "success", message: "作废成功！" });
							this.refreshAll();
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					});
				})
				.catch(() => {});
		},
		closeDialog() {
			this.showDialog = false;
			this.detailData = {};
			this.previewData = {};
			this.editGoodsList = [];
			this.historyList = [];
			this.keyId = "";
		}
	}
};
</script>

<style scoped>
.detail-desc {
	margin-bottom: 12px;
}
.detail-block-title {
	margin: 10px 0;
	font-weight: 600;
}
.output-way-list {
	margin-top: 12px;
}
.output-way-item {
	border: 1px solid var(--app-border);
	border-radius: 4px;
	padding: 12px 14px;
	margin-bottom: 10px;
	cursor: pointer;
	transition: all 0.2s;
}
.output-way-item:hover {
	border-color: var(--app-primary);
	background: var(--app-primary-soft);
}
.way-title {
	font-weight: 600;
	font-size: 14px;
	margin-bottom: 4px;
}
.way-desc {
	font-size: 12px;
	color: var(--app-text-muted);
}
.text-danger {
	color: var(--app-danger);
}
</style>
